module.exports = __webpack_public_path__ + "static/media/affordable-and-clean-energy.1841f3ed.png";


//////////////////
// WEBPACK FOOTER
// ./src/resources/affordable-and-clean-energy.png
// module id = 581
// module chunks = 0